export default __webpack_public_path__ + "static/media/icon_titulos.0d2669ef.svg";